export const additionalSounds = [
    {
        src: "sounds/hensohjun.mp3",
        id: "chickenWord",
    },
];
